import React from 'react';
import PacmanLoader from 'react-spinners/PacmanLoader';
import { Spinner, Application } from 'react-rainbow-components';

const AdminLoader = () => {
  return (
    <div className="p-5 position-fixed top-0 bottom-0 start-0 end-0" style={{ backgroundColor: 'var(--background)' }}>
      <div className="position-fixed top-50 start-50 translate-middle-x translate-middle-y">
        {/* <PacmanLoader color="var(--primary-text)" size="15px" /> */}
        <Spinner size="large" type="arc" variant="brand" className="position-fixed top-50">
          <img alt="autopaquete" src="/img/iconos/icono-ioenvio.svg" width="25px" height="25px" />
        </Spinner>
      </div>
    </div>
  );
};
export default AdminLoader;
